import { FaShop } from "react-icons/fa6";
import { Link } from "react-router-dom";

const TokoBoxSmall = (props) => {
  const { id, nama_toko } = props;

  return (
    <div className="col-start-start px-3 sm:px-5 py-2 w-full shadow-xs bg-slate-100 rounded-full">
      <Link className="row-start-center gap-3 w-full" to={`/toko/${id}`}>
        <FaShop className="bg-slate-500 text-white p-[0.6rem] rounded-full min-w-[2.8rem] min-h-[2.8rem]" />
        <div className="col-start-start">
          <span className="font-bold text-xs text-slate-700 leading-tight">
            {nama_toko}
          </span>
        </div>
      </Link>
    </div>
  );
};

export default TokoBoxSmall;
